import { RiskTolerance } from '@/assets/icons';
import {
  WebBodyText14,
  WebBodyText16,
} from '@fintronners/react-ui/src/GlobalStyling/webTypography';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

export const Infograph = () => {
  const { t } = useTranslation();
  return (
    <div className="shadow-40 border rounded-f1 text-center w-full px-2 pt-3 pb-5 flex flex-col items-center gap-6">
      <div className="flex flex-col gap-2 items-center">
        <Image src={RiskTolerance} alt="" width={36} height={36} />
        <WebBodyText16.Bold className="text-darkestBlue">
          {t('settings.security.riskProfile.infograph.title')}
        </WebBodyText16.Bold>
      </div>

      <div className="flex flex-col gap-4">
        <WebBodyText14.Regular className="text-darkestBlue">
          {t('settings.security.riskProfile.infograph.conservative.pre')}{' '}
          <WebBodyText14.Bold Component="span">
            {t('settings.security.riskProfile.infograph.conservative.bold')}
          </WebBodyText14.Bold>{' '}
          {t('settings.security.riskProfile.infograph.conservative.post')}
        </WebBodyText14.Regular>

        <WebBodyText14.Regular className="text-darkestBlue">
          {t('settings.security.riskProfile.infograph.moderate.pre')}{' '}
          <WebBodyText14.Bold Component="span">
            {t('settings.security.riskProfile.infograph.moderate.bold')}
          </WebBodyText14.Bold>{' '}
          {t('settings.security.riskProfile.infograph.moderate.post')}
        </WebBodyText14.Regular>

        <WebBodyText14.Regular className="text-darkestBlue">
          {t('settings.security.riskProfile.infograph.aggressive.pre')}{' '}
          <WebBodyText14.Bold Component="span">
            {t('settings.security.riskProfile.infograph.aggressive.bold')}
          </WebBodyText14.Bold>{' '}
          {t('settings.security.riskProfile.infograph.aggressive.post')}
        </WebBodyText14.Regular>
      </div>

      <div className="w-full h-[1px] bg-grey55" />

      <WebBodyText14.Regular>
        {t('settings.security.riskProfile.infograph.footer')}
      </WebBodyText14.Regular>
    </div>
  );
};
